import React, { Ref, useState } from "react";
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Colors } from "../palettes/colorPalette";

type CircleProgressProps = {
    name: string;
    numTicks: number;
    progress: React.MutableRefObject<number>; // Between 0 - 100
    onProgressFull?: () => void;
}

const containerStyle = css`
    position: absolute;
    left: 0;
    top: 0;
`;

const circleStyle = css`
    transition: 0.35s stroke-dashoffset;
	transform: rotate(-90deg);
    transform-origin: 50% 50%;
`;

const max_percent_offset = (2 * (22 / 7) * 40);

export const CircleProgress = (props: CircleProgressProps) => {

    React.useEffect(() => {
        const animation = document.getElementById(`${props.name}-circle`);
        animation?.addEventListener('transitionend', () => {
            if (props.onProgressFull !== undefined && props.progress.current === 0) {
                props.onProgressFull();
            }
        });
    }, []);

    return (
        <svg css={containerStyle} width="100%" viewBox="0 0 100 100" >
            <circle
                css={circleStyle}
                stroke="#cccccc"
                strokeWidth="4"
                fill="transparent"
                r="40"
                cx="50"
                cy="50"
            />
            <circle
                id={`${props.name}-circle`}
                css={circleStyle}
                stroke={Colors.UIHighlight}
                strokeWidth="4"
                strokeLinecap="round"
                strokeDasharray="251.428571429"
                strokeDashoffset={props.progress.current * max_percent_offset}
                fill="transparent"
                r="40"
                cx="50"
                cy="50"
            />
            {/* Put a point along a circle for each num ticks */}
            {Array.from(new Array(props.numTicks)).map((_, index) => {
                const angle = ((2 * Math.PI) / props.numTicks) * index;
                const x = 50 + 40 * Math.cos(angle - Math.PI / 2);
                const y = 50 + 40 * Math.sin(angle - Math.PI / 2);
                //console.log(angle, x, y);
                return (
                    <circle
                        key={`dot_${index}`}
                        stroke="#000"
                        strokeWidth="1"
                        fill="#000"
                        r="2"
                        cx={x}
                        cy={y}
                    />
                )
            })}
        </svg>
    )
}
